import React from 'react'

import type { ListCustomerProps } from './ListCustomerContent'

import { Link } from 'react-router-dom'

import ListCustomerContent from './ListCustomerContent'

export type { ListCustomerProps } from './ListCustomerContent'
export { LIST_CUSTOMER_H } from './ListCustomerContent'

export default React.memo<ListCustomerProps>(function ListCustomer({
  onPress,
  itemKey,
  ...rest
}): React.ReactElement {
  // onPress used to fall into ...rest below and never get called at all -
  // ListCustomerContent is typed to not read it, and navigation ran only
  // through the Link's own href. On native this same prop is what dispatches
  // the optimistic list-reorder (see ListCustomer.native.tsx) before
  // navigating, so that never happened on web either. Link's onClick runs
  // before its own default navigation, so this preserves normal navigation.
  const handleClick = React.useCallback((): void => {
    onPress?.(itemKey)
  }, [itemKey, onPress])

  return (
    <Link onClick={handleClick} style={linkStyle} to={`/customers/${itemKey}`}>
      <ListCustomerContent itemKey={itemKey} {...rest} />
    </Link>
  )
})

const linkStyle: React.CSSProperties = {
  textDecoration: 'none',
  color: 'inherit',
  display: 'block',
}
